module.exports = __webpack_public_path__ + "static/media/egg-sandwich.261f4f2a.jpg";